import React, { useEffect } from 'react';
import { userAppContext } from '../context/Context';

const ResetApiKey = ({ userResetApiKey, setApiKeyRequest }) => {
  const { setUserApiKey } = userAppContext();

  const userName = userResetApiKey[0];
  const userPass = userResetApiKey[1];

  const url = `${process.env.REACT_APP_URL_API_KEY}api/v1/public/resetkey`;

  useEffect(() => {
    if (userName !== undefined) {
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: userName,
          password: userPass,
        }),
      })
        .then(response => response.json())
        .then(result => {
          const key = result.payload?.apiKey;
          setUserApiKey(Array.isArray(key) ? key : key != null ? [key] : []);
          setApiKeyRequest(result);
        })
        .catch(error => {
          console.error('API Key reset error:', error);
        });
    }
  }, [userName]);

  return <span>{''}</span>;
};

export default ResetApiKey;
